<!--
 * @description: 
 * @Author: xinliu
 * @Date: 2022-03-15 09:27:02
 * @LastEditors: xinliu
 * @LastEditTime: 2022-03-18 14:43:22
-->
<template>
  <div>
    <el-form
      ref="autoForm"
      :class="formClass"
      :inline="inline"
      :model="form"
      label-width="140px"
    >
      <el-form-item
        v-for="item in formListData"
        :key="item.code"
        :label="item.title"
        :rules="item.rules"
        :prop="item.code"
      >
        <el-input
          v-if="item.type == 'input' && item.inputType == 'text'"
          v-model="form[item.code]"
          :placeholder="item.placeholder ? item.placeholder : ''"
          type="text"
          :show-word-limit="item.maxlength && item.maxlength > 0"
          :maxlength="item.maxlength ? item.maxlength : ''"
        ></el-input>
        <el-input
          v-if="item.type == 'input' && item.inputType == 'password'"
          v-model="form[item.code]"
          :placeholder="item.placeholder ? item.placeholder : ''"
          type="password"
          :show-word-limit="item.maxlength && item.maxlength > 0"
          :maxlength="item.maxlength ? item.maxlength : ''"
        ></el-input>
        <el-input
          type="textarea"
          v-if="item.type == 'textarea'"
          v-model="form[item.code]"
          :placeholder="item.placeholder"
          :maxlength="item.maxlength ? item.maxlength : ''"
          :show-word-limit="item.maxlength && item.maxlength > 0"
        >
        </el-input>
        <el-input
          type="number"
          v-if="item.type == 'input' && item.inputType == 'number'"
          v-model="form[item.code]"
          :placeholder="item.placeholder"
        >
        </el-input>
        <el-select
          v-if="item.type == 'select'"
          v-model="form[item.code]"
          :placeholder="item.placeholder"
        >
          <el-option
            v-for="selectOption in item.selectOptions"
            :key="selectOption.id"
            :label="selectOption.label"
            :value="selectOption.value"
          ></el-option>
        </el-select>
        <el-checkbox-group
          v-if="item.type == 'checkbox'"
          v-model="form[item.code]"
        >
          <el-checkbox
            v-for="checkOption in item.selectOptions"
            :key="checkOption.id"
            :label="checkOption.value"
            >{{ checkOption.label }}</el-checkbox
          >
        </el-checkbox-group>
        <el-radio-group v-if="item.type == 'radio'" v-model="form[item.code]">
          <el-radio
            v-for="radioOption in item.selectOptions"
            :key="radioOption.id"
            :label="radioOption.value"
            >{{ radioOption.label }}</el-radio
          >
        </el-radio-group>
        <el-switch
          v-if="item.type == 'switch'"
          v-model="form[item.code]"
        ></el-switch>
        <el-date-picker
          v-if="item.type == 'datepicker'"
          v-model="form[item.code]"
          type="date"
          :placeholder="item.placeholder"
          :value-format="item.valueFormat ? item.valueFormat : 'timestamp'"
          :pickerOptions="item.pickerOptions ? item.pickerOptions : ''"
        >
        </el-date-picker>
        <el-date-picker
          v-if="item.type == 'weekpicker'"
          v-model="form[item.code]"
          type="week"
          :format="item.format ? item.format : 'yyyy年 第 WW 周'"
          :placeholder="item.placeholder"
          :value-format="item.valueFormat ? item.valueFormat : 'timestamp'"
          :pickerOptions="item.pickerOptions ? item.pickerOptions : ''"
        >
        </el-date-picker>
        <el-date-picker
          v-if="item.type == 'monthpicker'"
          v-model="form[item.code]"
          type="month"
          :placeholder="item.placeholder"
          :format="item.format ? item.format : 'yyyy-MM'"
          :value-format="item.valueFormat ? item.valueFormat : 'timestamp'"
          :pickerOptions="item.pickerOptions ? item.pickerOptions : ''"
        >
        </el-date-picker>
        <el-date-picker
          v-if="item.type == 'yearpicker'"
          v-model="form[item.code]"
          type="year"
          :placeholder="item.placeholder"
          :format="item.format ? item.format : 'yyyy年'"
          :value-format="item.valueFormat ? item.valueFormat : 'timestamp'"
          :pickerOptions="item.pickerOptions ? item.pickerOptions : ''"
        >
        </el-date-picker>
        <el-date-picker
          v-if="item.type == 'daterangepicker'"
          v-model="form[item.code]"
          type="daterange"
          :range-separator="item.seprator ? item.seprator : '至'"
          :start-placeholder="
            item.startPlaceholder ? item.startPlaceholder : '开始日期'
          "
          :end-placeholder="
            item.endPlaceholder ? item.endPlaceholder : '结束日期'
          "
          :format="item.format ? item.format : 'yyyy-MM-dd'"
          :value-format="item.valueFormat ? item.valueFormat : 'timestamp'"
          :pickerOptions="item.pickerOptions ? item.pickerOptions : ''"
        >
        </el-date-picker>
        <el-date-picker
          v-if="item.type == 'monthrangepicker'"
          v-model="form[item.code]"
          type="monthrange"
          :range-separator="item.seprator ? item.seprator : '至'"
          :start-placeholder="
            item.startPlaceholder ? item.startPlaceholder : '开始月份'
          "
          :end-placeholder="
            item.endPlaceholder ? item.endPlaceholder : '结束月份'
          "
          :format="item.format ? item.format : 'yyyy-MM'"
          :value-format="item.valueFormat ? item.valueFormat : 'timestamp'"
          :pickerOptions="item.pickerOptions ? item.pickerOptions : ''"
        >
        </el-date-picker>
        <el-time-picker
          v-if="item.type == 'timepicker'"
          v-model="form[item.code]"
          :placeholder="item.placeholder"
          :picker-options="item.pickerOptions ? item.pickerOptions : {}"
          :value-format="item.valueFormat ? item.valueFormat : 'HH:mm:ss'"
          :pickerOptions="item.pickerOptions ? item.pickerOptions : ''"
        >
        </el-time-picker>
        <el-time-picker
          v-if="item.type == 'timerangepicker'"
          is-range
          v-model="form[item.code]"
          :range-separator="item.seprator ? item.seprator : '至'"
          :start-placeholder="
            item.startPlaceholder ? item.startPlaceholder : '开始时间'
          "
          :end-placeholder="
            item.endPlaceholder ? item.endPlaceholder : '结束时间'
          "
          :value-format="item.valueFormat ? item.valueFormat : 'HH:mm:ss'"
          :pickerOptions="item.pickerOptions ? item.pickerOptions : ''"
        >
        </el-time-picker>
        <el-date-picker
          v-if="item.type == 'datetimepicker'"
          v-model="form[item.code]"
          type="datetime"
          :placeholder="item.placeholder ? item.placeholder : '请选择'"
          :value-format="item.valueFormat ? item.valueFormat : 'timestamp'"
          :pickerOptions="item.pickerOptions ? item.pickerOptions : ''"
        >
        </el-date-picker>
        <el-date-picker
          v-if="item.type == 'datetimerangepicker'"
          v-model="form[item.code]"
          type="datetimerange"
          :picker-options="item.pickerOptions ? item.pickerOptions : {}"
          :range-separator="item.separator ? item.separator : '至'"
          :start-placeholder="
            item.startPlaceholder ? item.startPlaceholder : '开始时间'
          "
          :end-placeholder="
            item.endPlaceholder ? item.endPlaceholder : '结束时间'
          "
          :value-format="item.valueFormat ? item.valueFormat : 'timestamp'"
          :pickerOptions="item.pickerOptions ? item.pickerOptions : ''"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="submit" @click="submitForm('autoForm')"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: "CustomForm",
  props: {
    formClass: {
      type: String,
      default: () => ""
    },
    autoFormData: {
      type: Array,
      default: () => []
    },
    inline: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      formListData: [],
      form: {}
    };
  },
  watch: {
    form: {
      deep: true,
      handler(newVal) {
        console.log(newVal);
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log("true");
          this.$emit("getFormData", this.form);
        } else {
          console.log("false");
        }
      });
    }
  },
  mounted() {
    this.autoFormData.forEach((item) => {
      if (item.defaultValue) {
        this.$set(this.form, item.code, item.defaultValue);
      } else {
        if (item.type == "checkbox") {
          this.$set(this.form, item.code, []);
        } else if (item.type == "switch") {
          this.$set(this.form, item.code, false);
        } else {
          this.$set(this.form, item.code, "");
        }
      }
    });

    this.formListData = this.autoFormData;
  }
};
</script>


// WEBPACK FOOTER //
// src/CustomForm.vue